<template>
  <v-container fluid v-if="course">
    <page-header>
        <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/courses/management"
          >Course Management</v-breadcrumbs-item
        >
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :to="{name: 'CourseDetail', params: {id: $route.params.courseId, tab: 'tab-schedule'}}">
          {{ course.name }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
          {{ scheduleId ? 'Edit':'New'}} Schedule
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>
    
      <v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step
        :complete="step > 1"
        @click="step = 1"
        step="1"
      >
        Schedule
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="step > 2"
        @click="schedule.id ? step = 2:null"
        step="2"
      >
        Teacher
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step @click="schedule.id ? step = 3:null" step="3">
        Google Calendar
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content class="pa-0 pa-lg-5" step="1">

        <course-schedule-form
          v-if="loaded"
          @clickBack="cancel"
          @clickNext="save"
          v-model="schedule"
          backBtnLabel="Cancel"
          saveBtnLabel="Save & Continue"
        />
      </v-stepper-content>

      <v-stepper-content class="pa-0 pa-lg-5" step="2">
        <div class="ma-0 ma-lg-5">
          <course-schedule-teacher :showMenu="false" :key="timestamp" v-if="loaded && schedule.id" :courseSchedule="schedule"/>
        </div>

          <v-divider/>
        <div class="d-flex justify-space-between my-5 mx-2">
          <v-btn @click="step=1">Back</v-btn>
          <v-btn @click="step=3">Next</v-btn>
        </div>
      </v-stepper-content>

      <v-stepper-content class="pa-0 pa-lg-5" step="3">
        <course-schedule-google-event
           :key="timestamp" 
            @replacedEvent="updatedEvent"
          v-if="loaded && schedule.id"
            :courseSchedule="schedule"
          />
        
        <div class="d-flex justify-space-between my-5 mx-2">
          <v-btn @click="step=2">Back</v-btn>
          <v-btn @click="cancel">Done</v-btn>
        </div>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
  <!-- <div class="justify-space-between my-5 mx-2">
    <v-btn @click="cancel">Done</v-btn>
  </div> -->
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const CourseScheduleForm = () => import("@/components/course/CourseScheduleForm.vue");
const PageHeader = () => import("@/components/common/PageHeader.vue");
const CourseScheduleGoogleEvent = () =>
  import("@/components/google/CourseScheduleGoogleEvent.vue");
const CourseScheduleTeacher = () =>
  import("@/components/course/CourseScheduleTeacher.vue");

export default {
  
  data() {
    return {
      step: 1,
      loaded: false,
      schedule: {},
      course: null,
      courseId: this.$route.params.courseId,
      scheduleId: this.$route.params.scheduleId,
      timestamp: Date.now(),
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  mounted(){
    this.initCourse()
      .then( () => {
        this.initSchedule();
      })
  },
  methods: {
    ...mapActions([
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    async initCourse() {
      const courseId = this.$route.params.courseId;
      if (!courseId) {
        return;
      }

      const result = await this.$axios
        .get("classroom/course", {
          params: { courseId },
        })
        .then((resp) => {
          this.course = resp.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading course from server");
        });

      return result;
    },
    initSchedule(){
      if(this.scheduleId){
        const params = { id: this.scheduleId}
        this.$axios.get('/course-schedule/get-by-id', {params})
          .then( (resp) => {
            this.schedule = resp.data;
            this.loaded = true;
          })
      }
      else{
        this.loaded = true;
      }
    },
    save() {
      console.log("saving schedule");
      const data = {
          courseId: this.courseId,
          courseSchedules: [this.schedule]
      }
      this.$axios.post('/course-schedule/update', data)
        .then((resp) => {
          const newSchedules = resp.data.data;
          this.schedule = newSchedules[0];
          console.log('saved schedules: ', newSchedules)
          this.timestamp = Date.now();
          this.addSuccessMessage('Schedule updated')
          this.step = 2;
        })
        .catch( (resp) => {
            this.addErrorMessage(resp.data.message || resp.data);
        })
    },
    cancel(){
        console.log("cancel")
        this.$router.push({name: 'CourseDetail', params: {id: this.courseId, tab: 'tab-schedule'}})
    },
    updatedEvent(newCourseSchedule) {
      this.schedule = newCourseSchedule;
      this.timestamp = Date.now();
    },
  },
  components: {
    CourseScheduleForm,
    PageHeader,
    CourseScheduleGoogleEvent,
    CourseScheduleTeacher
  },
};
</script>

<style>
</style>